import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldAlert, Siren, Flag, Bot, UserX } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

const META = {
  ai_filter: { label: "IA filtrou mensagem", icon: Bot, cls: "border-violet-500/30" },
  ai_block: { label: "IA bloqueou perfil preventivamente", icon: ShieldAlert, cls: "border-violet-500/60 bg-violet-500/10" },
  report: { label: "Denúncia de usuário", icon: Flag, cls: "border-amber-500/40" },
  panic: { label: "Botão de pânico", icon: Siren, cls: "border-red-500/60 bg-red-500/10" },
  kick: { label: "Expulsão sumária", icon: UserX, cls: "border-white/10" },
};

export function AlertsPanel({ onCount }) {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("open");
  const load = () => api.get("/institution/alerts", { params: filter === "all" ? {} : { status: filter } }).then((r) => { setItems(r.data); if (filter === "open") onCount?.(r.data.length); });
  useEffect(() => { load(); }, [filter]); // eslint-disable-line react-hooks/exhaustive-deps

  const resolve = async (a, action) => {
    await api.post(`/institution/alerts/${a.id}/resolve`, { action });
    toast.success({ dismiss: "Alerta arquivado", unblock: "Perfil desbloqueado", block_permanent: "Perfil bloqueado permanentemente", remove_avatar: "Foto de perfil removida" }[action]);
    load();
  };

  return (
    <div className="space-y-4">
      <div className="flex gap-2">
        {[["open", "Abertos"], ["resolved", "Resolvidos"], ["all", "Todos"]].map(([k, l]) => (
          <button key={k} onClick={() => setFilter(k)} className={`rounded-full px-3 py-1.5 text-xs font-bold ${filter === k ? "bg-white text-black" : "bg-white/5 text-muted-foreground"}`} data-testid={`alerts-filter-${k}`}>{l}</button>
        ))}
      </div>
      {items.length === 0 && <p className="py-14 text-center text-muted-foreground" data-testid="alerts-empty">Nenhum alerta. O Guarda-Costas IA segue vigiando.</p>}
      <div className="space-y-2" data-testid="alerts-list">
        {items.map((a) => {
          const m = META[a.type] || META.report;
          return (
            <div key={a.id} className={`rounded-2xl border bg-card p-4 ${m.cls}`} data-testid={`alert-item-${a.id}`}>
              <div className="flex items-start gap-3">
                <m.icon size={18} className="mt-0.5 shrink-0" />
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center justify-between gap-2">
                    <p className="font-bold text-sm">{m.label}</p>
                    <span className="text-xs text-muted-foreground">{new Date(a.created_at).toLocaleString("pt-BR")}</span>
                  </div>
                  <p className="text-sm">{a.reason}</p>
                  <p className="text-xs text-muted-foreground">Sala: {a.room_title}{a.user_name ? ` · Perfil: ${a.user_name}` : ""}{a.reporter_name ? ` · Por: ${a.reporter_name}` : ""}</p>
                  {a.excerpt && (a.room_id?.startsWith("profile-")
                    ? <img src={a.excerpt} alt="Foto denunciada" className="mt-2 h-20 w-20 rounded-xl object-cover" data-testid={`alert-avatar-preview-${a.id}`} />
                    : <p className="mt-2 rounded-lg bg-black/30 p-2 text-xs italic text-white/70">"{a.excerpt}"</p>)}
                  {a.status === "open" && (
                    <div className="mt-3 flex flex-wrap gap-2">
                      <Button size="sm" variant="secondary" className="rounded-full" onClick={() => resolve(a, "dismiss")} data-testid={`alert-dismiss-${a.id}`}>Arquivar</Button>
                      {a.user_id && a.room_id?.startsWith("profile-") && <Button size="sm" variant="secondary" className="rounded-full" onClick={() => resolve(a, "remove_avatar")} data-testid={`alert-remove-avatar-${a.id}`}>Remover foto</Button>}
                      {a.user_id && <Button size="sm" variant="secondary" className="rounded-full" onClick={() => resolve(a, "unblock")} data-testid={`alert-unblock-${a.id}`}>Desbloquear perfil</Button>}
                      {a.user_id && <Button size="sm" className="rounded-full bg-red-600 hover:bg-red-500" onClick={() => resolve(a, "block_permanent")} data-testid={`alert-block-${a.id}`}>Bloquear definitivamente</Button>}
                    </div>
                  )}
                  {a.status === "resolved" && a.resolution && <p className="mt-2 text-xs text-emerald-400">Resolvido: {a.resolution}</p>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
